import { stringify } from 'qs';
import { useQuery } from '@tanstack/react-query';
import axiosInstance from 'ns_libs/nsAxios';
import API_ENDPOINTS, { QUERY_KEYS } from 'services/urls';
import { TimelineComment } from '../types';

type GetTimelineLatestCommentsParams = {
    orgId: string;
    dealId: number;
    timelineIds?: number[];
};

export const getTimelineLatestComments = async (
    orgId: string,
    dealId: number,
    timelineIds: number[],
): Promise<Record<string, TimelineComment>> => {
    const response = await axiosInstance.get<Record<string, TimelineComment>>(
        API_ENDPOINTS.TIMELINE_LATEST_COMMENTS(orgId, dealId),
        {
            params: { timeline_ids: timelineIds },
            paramsSerializer: params => stringify(params, { arrayFormat: 'repeat' }),
        },
    );
    return response.data;
};

export const useGetTimelineLatestComments = ({
    orgId, dealId, timelineIds,
}: GetTimelineLatestCommentsParams) => useQuery({
    queryKey: [QUERY_KEYS.TIMELINE_LATEST_COMMENTS, orgId, dealId, timelineIds],
    queryFn: () => getTimelineLatestComments(orgId, dealId, timelineIds ?? []),
    enabled: (timelineIds?.length ?? 0) > 0,
});
